import { convertToValidHTMLId } from "../../helpers"
import { PageSlug } from "../types"

export const generateQuestionId = (pageSlug: PageSlug, sectionTitle: string) => {
  return convertToValidHTMLId(`${pageSlug}-${sectionTitle}`)
}
